<template>
  <div class="splitScreen">
    <div class="date-display" v-if="formattedDate">
      {{'🕐'+ formattedDate }}
    </div>
    <div style="display: flex;justify-content: space-between;align-items: center">
      <el-switch
          v-model="keepAbsentStudents"
          style="margin-left: 20px;"
          active-text="保留缺勤"
          inactive-text="移除缺勤"
          @change="handleKeepAbsentChange">
      </el-switch>
      <p class="small">*数据每三分钟更新一次</p>
    </div>

    <div class="group-list">
      <div class="group-item" v-for="(item,index) in class_temp_list" :key="index" v-show="index<2">
        <div class="group-box">
          <div class="group-name">{{ item.xzmc }}</div>
          <!--          <div class="group-progress">排名：第<span style="margin:0 2px;color:#F56C6C;font-size: 28px">{{rank_num+index+1}}</span>名<span style="margin-left:10px">平均<span style="margin:0 2px;color:#67C23A;font-size: 28px">{{item.pjchl}}</span>个</span></div>-->
          <div class="group-progress"><span
              style="margin:0 2px;color:#F56C6C;font-size: 28px">{{ rank_num + index + 1 + '.' }}</span><span
              style="margin-left:10px">小组平均单词数:<span
              style="margin:0 2px;color:#67C23A;font-size: 28px">{{ item.pjchl }}</span>个</span></div>

          <div class="group-student">
            <div class="group-student-item" v-for="(itm,inx) in item.xsidAndMcRespList" :key="inx">
              <span style="font-size: 19px;font-weight: 500 ">{{ itm.xsxm }}</span>
              <div class="group-student-speed">
                <el-progress :stroke-width="12" :percentage="format(item.maxChl,itm.yzwl)*100"
                             :format="function(){return null}" :color="customColorMethod"></el-progress>
              </div>
              <div class="img-gif">
                <img style="width:60px;height:60px;" :src="require('../../../assets/images/teacher/q1.gif')" alt=""
                     v-show="inx==0">
                <img style="width:50px;height:50px;" :src="require('../../../assets/images/teacher/q2.gif')" alt=""
                     v-show="inx==1">
                <img style="width:50px;height:50px;" :src="require('../../../assets/images/teacher/q3.gif')" alt=""
                     v-show="inx==2">
                <img style="width:50px;height:50px;transform: scaleX(-1);"
                     :src="require('../../../assets/images/teacher/q6.gif')" alt=""
                     v-show="inx==3">
                <img style="width:60px;height:60px;transform: scaleX(-1);"
                     :src="require('../../../assets/images/teacher/q7.gif')" alt=""
                     v-show="inx==4">
                <img style="width:50px;height:50px;" :src="require('../../../assets/images/teacher/q4.gif')" alt=""
                     v-show="inx==5">
                <img style="width:50px;height:50px;transform: scaleX(-1);"
                     :src="require('../../../assets/images/teacher/q8.gif')" alt="" v-show="inx>5">
              </div>
              <span style="font-size:19px;color:#666;margin-left: 25px">{{ itm.yzwl }}个</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {classTempGroupGradeScreenApi, classTempGroupGradeScreenHave} from '@/api/teacher.js'

export default {
  name: 'splitScreen',

  data() {
    return {
      keepAbsentStudents: true, // 默认保留缺勤学生
      rank_num: 0,
      search_data: {},
      class_temp_list: [],
      maxChl: 0,//最高成绩
      formattedDate: ''
    }
  },

  mounted() {
    this.getClassTempScreenList()
    this.setTimer()
  },
  created() {
    this.search_data = this.$route.query;
    this.rank_num = (Number(this.search_data.currentPage) - 1) * Number(this.search_data.pageSize)
    this.formatDate();
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    // 切换处理方法
    handleKeepAbsentChange() {
      console.log(this.keepAbsentStudents)
      // 切换时重新获取数据
      this.getClassTempScreenList();
    },
    // 格式化日期
    formatDate() {
      let dateStr = this.search_data.creationDate;
      if (!dateStr) {
        dateStr = this.search_data.cjrq || '';
      }

      if (dateStr) {
        try {
          dateStr = decodeURIComponent(dateStr);

          dateStr = dateStr.replace(' 0000', 'Z').replace(' ', 'T');
          const date = new Date(dateStr);

          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');

          this.formattedDate = `${year}年${month}月${day}日`;

        } catch (error) {
          console.error('日期格式化错误:', error);
          this.formattedDate = '日期格式错误';
        }
      }
    },

    // 获取成绩排名
    getClassTempScreenList() {
      const data = this.search_data;
      data.currentPage = Number(data.currentPage)
      data.pageSize = Number(data.pageSize)
      console.log(data)

      if (this.keepAbsentStudents) {
        // 保留缺勤学生
        classTempGroupGradeScreenApi(data).then(res => {
          if (res.result) {
            this.class_temp_list = res.result.list;
          }
        })

      } else {
        // 移除缺勤学生
        classTempGroupGradeScreenHave(data).then(res => {
          if (res.result) {
            this.class_temp_list = res.result.list;
          }
        })
      }


    },
    setTimer() {
      this.timer = setInterval(() => {
        this.handelSearch()
      }, 10000)
    },


    format(average, num) {
      const percentage = (Number(num) / Number(average)).toFixed(2)
      console.log(percentage)
      return percentage
    },
    customColorMethod(percentage) {
      if (percentage < 50) {
        return '#E86452';
      } else if (percentage < 60) {
        return '#E6A23C';
      } else if (percentage < 70) {
        return '#5B8FF9';
      } else if (percentage < 80) {
        return '#6f7ad3';
      } else if (percentage < 90) {
        return '#5AD8A6';
      } else if (percentage > 90) {
        return '#67C23A';
      }
    },
  }
}
</script>
<style lang="scss" scope>
.splitScreen {
  .date-display {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #3a63e6;
    background: #f0f7ff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(58, 99, 230, 0.1);
  }

  .small {
    text-align: right;
    font-size: 12px;
    margin-right: 20px;
    color: red;
  }

  .group-list {
    padding: 10px;
    display: flex;
    align-items: flex-start;
    // align-items: center;
    .group-item {
      flex: 1;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      .group-box {
        .group-name {
          color: #3a63e6;
          font-size: 28px;
          font-weight: 600;
          margin: 10px 0;
        }

        .group-progress {
          padding: 2px 0;
          font-size: 22px;
          color: #3a63e6;
          font-weight: 600;
        }
      }
    }

    .group-student {
      .group-student-item {
        display: flex;
        align-items: center;
        width: 430px;

        span {
          width: 110px;
        }

        .group-student-speed {
          width: 200px;
          margin-left: 20px;

          .el-progress-bar {
            padding-right: 0 !important;
          }
        }

        .img-gif {
          width: 55px;
          height: 55px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 30px;
        }
      }
    }

    .group-item:first-child {
      border-right: #66b1ff dotted 2px;
    }
  }

  // /-----------------------------------------
}
</style>
